import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { viewClinician, viewClinicianClient } from "../../../Routes/RouterPage";
import { postRequest } from "../CustomHttp";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    {props}
  </Tooltip>
);

function ClinicianStatusSwitch({ id, status, parentAccount }) {
  const [toggleStatus, setToggleStatus] = useState(Number(status) === 1);

  useEffect(() => {
    setToggleStatus(Number(status) === 1);
  }, [status]);

  const changeStatus = async (userId, nextStatus) => {
    const getData = await postRequest(
      "/change-clinician-status",
      { id: userId, status: nextStatus ?? false },
      true
    );
    if (getData.status) {
      toast.success(getData.message);
      setToggleStatus(nextStatus);
    } else {
      toast.error(getData.message);
      setToggleStatus(!nextStatus);
    }
  };

  return (
    <div className="d-flex justify-content-center py-1 flex-shrink-0 text-right">
      <Form>
        <Form.Check
          type="switch"
          id={`clinician-status-switch-${id}`}
          checked={toggleStatus}
          disabled={parentAccount == 0}
          onChange={(e) => changeStatus(id, e.target.checked)}
        />
      </Form>
    </div>
  );
}

export const ClinicianColumns = [
  {
    Header: "Full Name",
    accessor: "full_name",
    Cell: ({ cell }) => (
      <div className="d-flex py-1 flex-shrink-0 text-right">
        <div className="me-2">
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(`view clients`)}
          >
            <Link to={viewClinicianClient.link + "/" + cell.row.original.id}>
              <i className="fas fa-eye"></i>
            </Link>
          </OverlayTrigger>
        </div>

        {/* <Link to={viewClinicianClient.link + "/" + cell.row.original.id}> */}
          {cell.row.original.full_name}
        {/* </Link> */}
        <div className="ms-2">
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(`view/edit provider`)}
          >
            <Link to={viewClinician.link + "/" + cell.row.original.id}>
              <i className="fas fa-pen" style={{color:"#c3c3c3"}}></i>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    ),
  },
  {
    Header: "Email",
    accessor: "email",
    Cell: ({ cell }) => (
      <div className="text-dark">{cell.row.original.email}</div>
    ),
  },
  {
    Header: "Phone Number",
    accessor: "phone_number",
    Cell: ({ cell }) => (
      <div className="text-dark">{cell.row.original.phone_number}</div>
    ),
  },
  {
    Header: "Role",
    accessor: "role_name",
    Cell: ({ cell }) => (
      <div className="text-dark">{cell.row.original.role_name}</div>
    ),
  },
  {
    Header: () => (
      <div style={{ textAlign: "center", marginRight: "22px" }}>
        Active/Inactive
      </div>
    ),
    accessor: "action",
    Cell: ({ cell }) => (
      <ClinicianStatusSwitch
        id={cell.row.original.id}
        status={cell.row.original.status}
        parentAccount={cell.row.original.parent_account}
      />
    ),
  },
];
